// eslint-disable-next-line no-restricted-imports -- Required for Node.js script compatibility
import { ROUTES } from '../router/const.js'
export const BASE_DOMAIN = process.env.VITE_BASE_DOMAIN || process.env.BASE_DOMAIN

// Thumbnail path for Open Graph and social sharing
export const THUMBNAIL_PATH = '/thumbnail.png'

// Default fallback for routes without route-specific meta; image/url use BASE_DOMAIN from env at build/runtime.
export const DEFAULT_META = {
  title: 'SubTrace by Armadillex | Subprocessor Mapping',
  description:
    'SubTrace by Armadillex helps organizations explore subprocessor relationships, vendor dependencies, and infrastructure intelligence through interactive Subprocessor Maps.',
  image: `${BASE_DOMAIN}${THUMBNAIL_PATH}`,
  url: BASE_DOMAIN,
}

// ============================================================================
// ROUTES METADATA
// ============================================================================
// For route meta config

/** Shared by map routes; title updates when useMetadata.setDynamicData supplies vendorName. */
function getMapRouteDynamicMeta(_route, dynamicData) {
  if (!dynamicData?.vendorName) return null
  return {
    title: `${dynamicData.vendorName} | Subprocessor Map`,
  }
}

export const ROUTES_METADATA = {
  // Root `/` redirects to login in-app; bots still request `/` and need static meta (not SPA shell).
  [ROUTES.APP]: {
    staticPath: '/',
    meta: {
      title: DEFAULT_META.title,
      description: DEFAULT_META.description,
    },
  },

  [ROUTES.LOGIN]: {
    staticPath: '/login',
    meta: {
      title: 'SubTrace by Armadillex | Access Subprocessor Map',
      description:
        'Access your SubTrace workspace to explore interactive Subprocessor Maps, vendor relationships, and infrastructure intelligence.',
    },
  },

  [ROUTES.LINK_LOGIN]: {
    staticPath: '/link/:linkId',
    meta: {
      title: 'SubTrace by Armadillex | Open Subprocessor Map',
      description:
        'Open your SubTrace workspace to explore shared Subprocessor Maps, dependency paths, and vendor infrastructure relationships.',
    },
    getDynamicMeta: getMapRouteDynamicMeta,
  },

  [ROUTES.GRANT_SELECT]: {
    staticPath: '/grant-select',
    meta: {
      title: 'SubTrace by Armadillex | Select Subprocessor Map',
      description:
        'Choose a SubTrace workspace to continue exploring interactive Subprocessor Maps and dependency intelligence.',
    },
  },

  [ROUTES.MAP]: {
    staticPath: '/map',
    meta: {
      title: 'SubTrace by Armadillex | Subprocessor Map',
      description:
        'Explore interactive Subprocessor Maps with vendor relationships, dependency paths, and infrastructure intelligence powered by SubTrace.',
    },
    getDynamicMeta: getMapRouteDynamicMeta,
  },
}
